// extracted by mini-css-extract-plugin
export default {"edgebutton":"EdgeLine_edgebutton__IfBVM","crossButton":"EdgeLine_crossButton__49dXm"};